import { render, staticRenderFns } from "./ArticlePriceModal.vue?vue&type=template&id=0f23f744&"
import script from "./ArticlePriceModal.vue?vue&type=script&lang=js&"
export * from "./ArticlePriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports